module.exports = "/images/stop.png?c8ff3d66155b2352993f71801260abd0";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/stop.png
// module id = tETc
// module chunks = 0